import React, { useState } from "react";
import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const MenuItem = ({ item, onAddToCart }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [quantity, setQuantity] = useState(1);

  const getSpiceIcon = (level) => {
    const icons = {
      mild: "🌶️",
      medium: "🌶️🌶️",
      hot: "🌶️🌶️🌶️",
      "extra-hot": "🌶️🌶️🌶️🌶️",
    };
    return icons?.[level] || "";
  };

  const getDietaryBadge = (dietary) => {
    const badges = {
      vegetarian: {
        icon: "Leaf",
        color: "var(--color-success)",
        bg: "var(--color-success)/10",
        label: "Veg",
      },
      vegan: {
        icon: "Sprout",
        color: "var(--color-trust-green)",
        bg: "var(--color-trust-green)/10",
        label: "Vegan",
      },
      "gluten-free": {
        icon: "Wheat",
        color: "var(--color-brand-amber)",
        bg: "var(--color-brand-amber)/10",
        label: "GF",
      },
    };
    return badges?.[dietary];
  };

  const handleAddToCart = () => {
    onAddToCart({ ...item, quantity });
    setQuantity(1);
  };

  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300 group">
      <div className="relative h-48 overflow-hidden">
        <Image
          src={item?.image}
          alt={item?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

        {item?.isNew && (
          <div className="absolute top-3 left-3 px-3 py-1 bg-[var(--color-accent)] rounded-full">
            <span className="text-xs font-semibold text-white">NEW</span>
          </div>
        )}

        {item?.isPopular && (
          <div className="absolute top-3 right-3 px-3 py-1 bg-[var(--color-primary)] rounded-full flex items-center gap-1">
            <Icon name="TrendingUp" size={12} color="#FFFFFF" />
            <span className="text-xs font-semibold text-white">Popular</span>
          </div>
        )}

        <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            {item?.dietary?.map((diet, index) => {
              const badge = getDietaryBadge(diet);
              return badge ? (
                <div
                  key={index}
                  className="px-2 py-1 rounded-full flex items-center gap-1"
                  style={{ backgroundColor: badge?.bg }}
                >
                  <Icon name={badge?.icon} size={12} color={badge?.color} />
                  <span
                    className="text-xs font-medium"
                    style={{ color: badge?.color }}
                  >
                    {badge?.label}
                  </span>
                </div>
              ) : null;
            })}
          </div>
          <div className="px-2 py-1 bg-white/90 backdrop-blur-sm rounded-full">
            <span className="text-sm font-semibold">
              {getSpiceIcon(item?.spiceLevel)}
            </span>
          </div>
        </div>
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between mb-2">
          <h3 className="text-lg font-bold text-[var(--color-foreground)] group-hover:text-[var(--color-primary)] transition-colors">
            {item?.name}
          </h3>
          <div className="text-right">
            <p className="text-xl font-bold text-[var(--color-primary)]">
              ₹{item?.price}
            </p>
            {item?.originalPrice && (
              <p className="text-sm text-[var(--color-muted-foreground)] line-through">
                ₹{item?.originalPrice}
              </p>
            )}
          </div>
        </div>

        <p className="text-sm text-[var(--color-muted-foreground)] mb-3 line-clamp-2">
          {item?.description}
        </p>

        {isExpanded && (
          <div className="mb-4 space-y-3 animate-fade-in">
            <div className="pt-3 border-t border-[var(--color-border)]">
              <p className="text-xs font-semibold text-[var(--color-foreground)] mb-2">
                Ingredients:
              </p>
              <p className="text-xs text-[var(--color-muted-foreground)]">
                {item?.ingredients}
              </p>
            </div>

            <div className="flex items-center gap-4 text-xs text-[var(--color-muted-foreground)]">
              <div className="flex items-center gap-1">
                <Icon name="Flame" size={14} color="var(--color-accent)" />
                <span>{item?.calories} cal</span>
              </div>
              <div className="flex items-center gap-1">
                <Icon name="Clock" size={14} color="var(--color-primary)" />
                <span>{item?.prepTime} min</span>
              </div>
            </div>

            {item?.allergens && item?.allergens?.length > 0 && (
              <div className="bg-[var(--color-warning)]/10 border border-[var(--color-warning)]/20 rounded-lg p-2">
                <p className="text-xs font-semibold text-[var(--color-warning)] mb-1">
                  Allergen Info:
                </p>
                <p className="text-xs text-[var(--color-muted-foreground)]">
                  {item?.allergens?.join(", ")}
                </p>
              </div>
            )}
          </div>
        )}

        {/* <div className="flex items-center gap-2 mt-4">
          <div className="flex items-center border border-[var(--color-border)] rounded-lg overflow-hidden">
            <button
              onClick={() => setQuantity(Math.max(1, quantity - 1))}
              className="px-3 py-2 hover:bg-[var(--color-muted)] transition-colors"
              aria-label="Decrease quantity"
            >
              <Icon name="Minus" size={16} />
            </button>
            <span className="px-4 py-2 font-semibold text-[var(--color-foreground)] min-w-[40px] text-center">
              {quantity}
            </span>
            <button
              onClick={() => setQuantity(quantity + 1)}
              className="px-3 py-2 hover:bg-[var(--color-muted)] transition-colors"
              aria-label="Increase quantity"
            >
              <Icon name="Plus" size={16} />
            </button>
          </div>

          <Button
            variant="default"
            size="default"
            iconName="ShoppingCart"
            iconPosition="left"
            onClick={handleAddToCart}
            className="flex-1"
          >
            Add to Cart
          </Button>
        </div> */}

        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-full mt-3 flex items-center justify-center gap-2 text-sm font-medium text-[var(--color-primary)] hover:text-[var(--color-accent)] transition-colors"
        >
          <span>{isExpanded ? "Show Less" : "View Details"}</span>
          <Icon name={isExpanded ? "ChevronUp" : "ChevronDown"} size={16} />
        </button>
      </div>
    </div>
  );
};

export default MenuItem;
